module.exports = __webpack_public_path__ + "static/netflix-bg-5ee9d30c01839551877fd34caccdc4c4.png";